module.exports = __webpack_public_path__ + "media/images/lb/143-d4b1c314aabb9ed80b65553063c906df.svg";